const jwt_decode = require("jwt-decode");

const anonymousUser = {
	login: "anonym",
	name: "anonym",
	identityId: null,
	exp: 0,
	isLoggedIn: false,
	permissions: []
}

/**
	instance of current user. It it intended as cache for current user
 */
let _currentUser = null;

class CurrentUser {
	constructor(userData = anonymousUser) {
		this._login = userData.login || anonymousUser.login;
		this._name = userData.name || anonymousUser.name;
		this._identityId = userData.identityId || anonymousUser.identityId;
		this._exp = userData.exp || anonymousUser.exp;
		this._isLoggedIn = userData.isLoggedIn || anonymousUser.isLoggedIn;
		this._permissions = userData.permissions || anonymousUser.permissions;
	}

	static fromJwtToken() {
		let token_match = document.cookie.match("(?:authToken=)(?<token>.*?)(?:;|$)");

		let token_data = (token_match && token_match.groups && token_match.groups.token && jwt_decode(token_match.groups.token)) || anonymousUser;

		if ((token_data.exp * 1000) > Date.now()) {
			token_data.isLoggedIn = true;

			return new CurrentUser(token_data);
		} else {
			return new CurrentUser(anonymousUser);
		}
	}

	hasPermission(perm) {
		return (this._permissions || []).includes(perm);
	}

	get login() {
		return this._login
	}

	get identityId() {
		return this._identityId
	}

	get name() {
		return this._name
	}

	get exp() {
		return this._exp
	}

	get isLoggedIn() {
		return this._isLoggedIn
	}

	get permissions() {
		return this._permissions
	}
}

function getCurrentUser() {
	if (_currentUser && ((_currentUser._exp * 1000) > Date.now())) {
		// there is nonexpired cached current User

		return _currentUser;
	} else {
		_currentUser = CurrentUser.fromJwtToken();

		return _currentUser;
	}
}

module.exports = {
	CurrentUser: CurrentUser,
	getCurrentUser: getCurrentUser
}



//////////////////
// WEBPACK FOOTER
// ./src/security/browser/CurrentUser.js
// module id = 7
// module chunks = 0